export default __webpack_public_path__ + "static/media/2_0154.d3faf9d6.webp";